module.exports = __webpack_public_path__ + "static/img/h5-8.3bfec9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/h5-8.png
// module id = RS3d
// module chunks = 1